import { Box, Flex } from "grid-styled";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import rejectImport from "./rejectImportMutation";

import { environment } from "pstat-anywhere/relay";
import { TextareaFormElement } from "pstat-design-system/inputs/FormElements";
import Modal, { ModalFooter } from "pstat-design-system/modal";
import { Button } from "pstat-design-system/shared/Button";


const RejectImportModal = ({ isOpen, onClose, importPk, reloadPage }) => {
  const [processing, setProcessing] = useState(false);
  const [comment, setComment] = useState("");
  const { t } = useTranslation();

  const isEnterKey = event => event.key === "Enter";
  const handleRejectImportKeyDown = event => {
    if (isEnterKey(event)) {
      handleRejectImport(event);
    }
  };
  const handleCancelKeyDown = event => {
    if (isEnterKey(event)) {
      onClose();
    }
  };
  const handleRejectImport = event => {
    const variables = {
      importPk,
      comment
    };
    rejectImport(environment, variables, (response, errors) => {
      if (errors) {
        throw new Error("error rejecting import");
      }
      if (response.rejectImportDocument.ok) {
        onClose();
        setProcessing(false);
        reloadPage();
      } else {
        throw new Error(response.rejectImportDocument.error.statusCode);
      }
    });
    setProcessing(true);
  };

  return (
    <Modal
      contentLabel={t(
        "implementation.documentsRequiringAcceptance.rejectModal.heading"
      )}
      isOpen={isOpen}
      onRequestClose={onClose}
      renderFooter={() => (
        <ModalFooter>
          <Flex width={1} px={5} py={3} justifyContent="space-between">
            <Box>
              <Button
                id="reject_import_button"
                buttonStyle="secondary"
                onClick={handleRejectImport}
                onKeyDown={handleRejectImportKeyDown}
                processing={processing}
                disabled={comment.length === 0}
              >
                {t(
                  "implementation.documentsRequiringAcceptance.rejectModal.rejectButton"
                )}
              </Button>
            </Box>
            <Box>
              <Button
                buttonStyle="tertiary"
                onClick={onClose}
                onKeyDown={handleCancelKeyDown}
              >
                {t("buttons.cancel")}
              </Button>
            </Box>
          </Flex>
        </ModalFooter>
      )}
    >
      <Flex flexDirection="column" px={5} pt={3}>
        <TextareaFormElement
          id="reject_modal_comment_box"
          label={t(
            "implementation.documentsRequiringAcceptance.rejectModal.commentLabel"
          )}
          value={comment}
          onChange={event => setComment(event.target.value)}
          required={true}
        />
      </Flex>
    </Modal>
  );
};

export default RejectImportModal;
